import Phaser from 'phaser';
import { MENU_SFX, loadSfxGroup } from '../audio/sfx-groups.js';
import { isSpectateMode, getSpectateAgentId } from '../spectate.js';

/**
 * Boot scene — keep this MINIMAL. Only load what's needed for
 * MainMenuScene to render. Everything else (per-scene SFX groups,
 * sprites, music) is lazy-loaded by the scene that uses it.
 *
 * Visual menu assets (the 3 portrait .webp circles, banner.webp,
 * crupier.webp) are loaded by MainMenuScene.preload itself.
 */
export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  preload(): void {
    // Universal click/hover + menu portal SFX. ~6 small files.
    loadSfxGroup(this, MENU_SFX);
  }

  create(): void {
    // Generate particle textures
    const portalParticle = this.add.graphics();
    portalParticle.fillStyle(0xffffff, 1);
    portalParticle.fillRect(0, 0, 3, 3);
    portalParticle.generateTexture('portal_particle', 3, 3);
    portalParticle.destroy();

    // Generate placeholder textures for assets not yet created
    this.generatePlaceholders();

    // Detect mobile
    const isMobile = this.sys.game.device.os.android ||
      this.sys.game.device.os.iOS ||
      this.sys.game.device.os.windowsPhone;
    this.registry.set('isMobile', isMobile);

    // Spectator embed: skip the menu entirely and go straight to the live
    // arena as a read-only observer, following the given agent's snake.
    if (isSpectateMode()) {
      this.scene.start('GameScene', { spectate: true, spectateSnakeId: getSpectateAgentId() });
      return;
    }

    this.scene.start('MainMenuScene');
  }

  private generatePlaceholders(): void {
    const cellSize = 16;
    this.createRect('wall', cellSize, cellSize, 0x333333);
    this.createRect('cell_empty', cellSize, cellSize, 0x111111);
  }

  private createRect(key: string, w: number, h: number, color: number): void {
    const graphics = this.add.graphics();
    graphics.fillStyle(color, 1);
    graphics.fillRect(0, 0, w, h);
    graphics.generateTexture(key, w, h);
    graphics.destroy();
  }
}
